import { render, staticRenderFns } from "./CheckProducts.vue?vue&type=template&id=168ec3ec&scoped=true&"
import script from "./CheckProducts.vue?vue&type=script&lang=js&"
export * from "./CheckProducts.vue?vue&type=script&lang=js&"
import style0 from "./CheckProducts.vue?vue&type=style&index=0&id=168ec3ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168ec3ec",
  null
  
)

export default component.exports